import { fetchVersion } from "@/helpers/hooks/fetchVersion.ts";
import { LocalStorageKey } from "@/helpers/interfaces/LocalStorageKey.ts";
import { useNewVersionStore } from "@/stores/NewVersionStore/NewVersionStore.ts";

// Function to check for app updates
export const hasUpdate = async (): Promise<boolean> => {
  // VITE_APP_MODE must be set for staging and dev environments
  const localStorageKey = `${LocalStorageKey.SwenAppVersion}-${
    import.meta.env.VITE_APP_MODE || "production"
  }`;

  const latestVersion = await fetchVersion();
  const currentVersion = localStorage.getItem(localStorageKey);
  const setHasNewVersion = useNewVersionStore.getState().setHasNewVersion;

  // If no version is stored, set the latest version and indicate no update needed
  if (latestVersion && !currentVersion) {
    localStorage.setItem(localStorageKey, latestVersion);
    setHasNewVersion(false);
    return false;
  }

  // If the latest version is different from the current version, update and indicate an update is available
  if (latestVersion && latestVersion !== currentVersion) {
    localStorage.setItem(localStorageKey, latestVersion);
    setHasNewVersion(true);
    return true;
  }

  // No update is necessary
  setHasNewVersion(false);
  return false;
};
